import { post } from '@/utils/request'


/* 标记已读信息 */

export function message_mark_read(data) {
  return post('message_mark_read', data)
}